import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { NotificationFilterOptionsResponse } from 'src/apis/notification-service/types';
import type { NotificationsRequest } from 'src/apis/notification-service/use-notifications';
import { useAxios, type Successful } from 'src/hooks/use-axios';

type Props = {
  url: string;
};

type HookOptions = {
  notifications: Successful<NotificationsRequest>;
  context?: string | null;
};

export function useNotificationFilterOptions({
  notifications,
  context,
}: HookOptions) {
  const filterOptions = useAxios(
    (axios, baseConfig, { url }: Props) =>
      axios.request<NotificationFilterOptionsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const link =
      notifications.response.data._links.getNotificationFilterOptions.href;
    const url = urlTemplate.parse(link).expand({ context });

    filterOptions.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [notifications.response, context]);

  return filterOptions;
}

export type NotificationFilterOptionsRequest = ReturnType<
  typeof useNotificationFilterOptions
>;
